// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/resource/v1/event.proto (package msh.resource.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { ActivityLevelTrait_ActivityLevelEvent } from "../../trait/activities/v1/activity_level_pb";
import { FallTrait_FallEvent } from "../../trait/activities/v1/fall_pb";
import { PresenceTrait_PresenceEvent } from "../../trait/activities/v1/presence_pb";
import { HeartRateTrait_HeartRateEvent } from "../../trait/telemetry/v1/heart_rate_pb";
import { RespirationTrait_RespirationEvent } from "../../trait/telemetry/v1/respiration_pb";
import { DistanceTrait_DistanceEvent } from "../../trait/telemetry/v1/distance_pb";
import { OnlineOfflineTrait_OnlineOfflineChangedEvent } from "../../trait/actuator/v1/online_offline_pb";
import { AudioClassificationTrait_AudioClassificationEvent } from "../../trait/activities/v1/audio_classification_pb";
import { TemperatureTrait_TemperatureChangedEvent } from "../../trait/sensor/v1/temperature_pb";
import { HumidityTrait_HumidityChangedEvent } from "../../trait/sensor/v1/humidity_pb";
import { PressureTrait_PressureChangedEvent } from "../../trait/sensor/v1/pressure_pb";
import { LightIntensityTrait_LightIntensityChangedEvent } from "../../trait/sensor/v1/light_pb";
import { AirQualityTrait_AirQualityChangedEvent } from "../../trait/sensor/v1/air_quality_pb";
import { TimeRange } from "../../common/v1/common_pb";

/**
 * @generated from message msh.resource.v1.Event
 */
export const Event = proto3.makeMessageType(
  "msh.resource.v1.Event",
  () => [
    { no: 8, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 1, name: "activity_level", kind: "message", T: ActivityLevelTrait_ActivityLevelEvent, oneof: "type" },
    { no: 2, name: "fall", kind: "message", T: FallTrait_FallEvent, oneof: "type" },
    { no: 3, name: "presence", kind: "message", T: PresenceTrait_PresenceEvent, oneof: "type" },
    { no: 4, name: "heart_rate", kind: "message", T: HeartRateTrait_HeartRateEvent, oneof: "type" },
    { no: 5, name: "respiration_rate", kind: "message", T: RespirationTrait_RespirationEvent, oneof: "type" },
    { no: 6, name: "distance", kind: "message", T: DistanceTrait_DistanceEvent, oneof: "type" },
    { no: 7, name: "connectivity", kind: "message", T: OnlineOfflineTrait_OnlineOfflineChangedEvent, oneof: "type" },
    { no: 14, name: "audio_classification", kind: "message", T: AudioClassificationTrait_AudioClassificationEvent, oneof: "type" },
    { no: 9, name: "temperature", kind: "message", T: TemperatureTrait_TemperatureChangedEvent, oneof: "type" },
    { no: 10, name: "humidity", kind: "message", T: HumidityTrait_HumidityChangedEvent, oneof: "type" },
    { no: 11, name: "pressure", kind: "message", T: PressureTrait_PressureChangedEvent, oneof: "type" },
    { no: 12, name: "light_intensity", kind: "message", T: LightIntensityTrait_LightIntensityChangedEvent, oneof: "type" },
    { no: 13, name: "air_quality", kind: "message", T: AirQualityTrait_AirQualityChangedEvent, oneof: "type" },
  ],
);

/**
 * @generated from message msh.resource.v1.EventFilter
 */
export const EventFilter = proto3.makeMessageType(
  "msh.resource.v1.EventFilter",
  () => [
    { no: 1, name: "time_range", kind: "message", T: TimeRange },
  ],
);

